import { render, staticRenderFns } from "./beneficial-ownership-table-row.vue?vue&type=template&id=3d20727e&"
import script from "./beneficial-ownership-table-row.vue?vue&type=script&lang=ts&"
export * from "./beneficial-ownership-table-row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports